/*
  Back from checkout showed an empty cart (QA 2026-09-14).

  Pressing Back re-reads this page from the browser's HTTP cache - the copy
  rendered BEFORE the AJAX add to cart - or restores it frozen from the
  back/forward cache. Either way the bag count and drawer are stale, though the
  cart itself is intact. <body data-cart-sig> holds what the server rendered;
  if the real cart differs, reload once. A reload has navigation type "reload",
  so this cannot loop.

  cart.js is fetched with cache: 'no-store' on purpose: on a back navigation
  the browser may serve that request from its HTTP cache too, which would hand
  back the same stale cart and the check would never fire.

  Dawn's AJAX add and quantity changes do not update data-cart-sig. That is
  intended: the attribute always holds what the server rendered, which is
  exactly what a cached copy shows. Loaded from snippets/mug-head.liquid.
*/
(function () {
  window.addEventListener('pageshow', function (event) {
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (!event.persisted && !(nav && nav.type === 'back_forward')) return;

    var shown = document.body.getAttribute('data-cart-sig');
    if (shown === null) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (shown !== cart.item_count + '-' + cart.total_price) window.location.reload();
      })
      .catch(function () {});
  });
})();
